module.exports = __webpack_public_path__ + "img/roseta-san-miguel-de-lillo-filtra.2069aeca.png";